import type { Resource } from '../../';
export const checkout_shipping_errors_cannotShipToPOBox: Resource = {"default":"Sorry, we do not support shipping to PO Boxes yet. Please enter another address."};
